import React, { useState } from 'react';
import { Card } from 'react-bootstrap';

import './ReportTemplate.css';
import SectionResult from './SectionResult';
import StudentForm from '../../Form/Components/Student/StudentForm';
import HousingForm from '../../Form/Components/Housing/HousingForm';
import AdditionalForm from '../../Form/Components/Additional/AdditionalForm';
import FinancialForm from '../../Form/Components/Financial/FinancialForm';


export default function ReportTemplate (props) {

    const [semester, setSemester] = useState("Both")

    const { student, house_meal, finance, additional } = props.data
    const { total, tuition_n_fees, housing_n_meal, other_expenses, financial_aid } = props.estimate  


    return(
        <>
            <Card>
                <Card.Body>
                <div className="entry-result">
                <label htmlFor="semester">Semester</label>
                <span id="semester" className="btn-block">
                    <button type="button" className={semester === "Both" ? "active" : ""} onClick={() => setSemester("Both")}>Both</button>
                    <button type="button" className={semester === "Fall" ? "active" : ""} onClick={() => setSemester("Fall")}>Fall</button>
                    <button type="button" className={semester === "Spring" ? "active" : ""} onClick={() => setSemester("Spring")}>Spring</button>
                </span>
                </div>
                </Card.Body>
            </Card>


            <SectionResult 
                title={'Estimated Totals'} 
                data={total}
                semester={semester} />

            <SectionResult 
                title={'Tuition and Fees'} 
                data={tuition_n_fees} 
                semester={semester}
                isSectionValid={() => !props.invalid.includes("student")}
                form={<StudentForm data={student} changeState={(newState) => props.changeState("student", newState)} invalid={props.invalid.includes("student")} />}
                refresh={props.refresh} />
            
            <SectionResult 
                title={'Housing and Meal Cost'} 
                data={housing_n_meal} 
                semester={semester}
                isSectionValid={() => !props.invalid.includes("house_meal")}
                form={<HousingForm data={house_meal} student={student} changeState={(newState) => props.changeState("house_meal", newState)} invalid={props.invalid.includes("house_meal")} />} 
                refresh={props.refresh}/>

            <SectionResult 
                title={'Additional Expenses'} 
                data={other_expenses} 
                semester={semester}
                isSectionValid={() => !props.invalid.includes("additional")}
                form={<AdditionalForm data={additional} student={student} changeState={(newState) => props.changeState("additional", newState)} invalid={props.invalid.includes("additional")} />}
                refresh={props.refresh} />

            <SectionResult 
                title={'Financial Aid'} 
                data={financial_aid} 
                semester={semester}
                isSectionValid={() => !props.invalid.includes("finance")}
                form={<FinancialForm data={finance} changeState={(newState) => props.changeState("finance", newState)} invalid={props.invalid.includes("finance")} />} 
                refresh={props.refresh} />


            <hr/>
            <div style={{ fontSize: "11px", textAlign: "left",}}>
                <u><b>Input Parameters</b></u>
                <div>
                <u>Residency</u> : <span>{student.residency}</span>,
                <u>Student Status</u> : <span>{student.classification}</span>,
                <u>Area of Study</u> : <span>{student.studyArea}</span>
                </div>
            </div>
            <div className="result-disclaimer">
                <ol>
                <li>
                    Course fees, non-University expenses and other university charges (e.g. athletic tickets, Cy-Cash, books,
                    off-campus rent, and personal expenses) can be included in this estimate under the fixed costs section; for information about books refer to
                    <a href="http://www.isubookstore.com" target="_blank" rel="noreferrer">www.isubookstore.com</a>; for information
                    about athletic tickets refer to <a href="http://www.cyclones.com" target="_blank" rel="noreferrer">www.cyclones.com</a> (Fixed Costs will not show up in the pdf but the total will stay the same)
                </li>
                <li>
                    Financial aid may be adjusted if you are attending less than full time, the FAFSA is updated, or new scholarships
                    are reported. Values listed here are based on information self-reported in this tool.
                </li>
                <li>
                    Tuition and Fees are estimates and may be different than listed above: for tuition and fee details refer to
                    <a href="http://www.registrar.iastate.edu/fees/" target="_blank" rel="noreferrer">www.registrar.iastate.edu/fees</a>; for
                    information about Distance Education refer to <a href="http://www.distance.iastate.edu" target="_blank" rel="noreferrer">www.distance.iastate.edu</a>
                </li>
                <li>
                    The loan amount displayed is the net amount after subtracting origination fees. An origination fee is an upfront
                    fee charged by a lender for the cost of administering a loan, reducing the amount that will apply to the University
                    Bill. The federal government applies this fee to all Direct, Parent PLUS, and Graduate PLUS federal
                    education loans. Private loan origination fees vary by loan program; please refer to your lender for more information.
                </li>
                <li>
                    Direct loans have both annual and cumulative loan limits. Direct PLUS and private education loans require
                    credit approval. Total financial aid, including loans, cannot exceed the published Cost of Attendance.
                </li>
                </ol>
            </div>
        </>
    )
}